import percent from 'percent';

export function percentageDifference (a, b) {
    if (b === 0) { a++; b++ }
    return percent.sign((((a - b)/Math.abs(b))*100).toFixed(2));
};

export function getMargin (revenue, payout) {
    return ((((revenue - payout)/(revenue === 0 ? 1 : revenue))*10000).toFixed(0))/100;  
};